import SaleItemList from "./SaleItemList";

const saleItemRoutes = [
    {
        path: "/SaleItem/sale-item-list",
        component: SaleItemList,
        permission: "Permissions.SaleItems.View",
      },
];
export default saleItemRoutes;